import { render, staticRenderFns } from "./ConversationDetail.vue?vue&type=template&id=f0090338&scoped=true&"
import script from "./ConversationDetail.vue?vue&type=script&lang=js&"
export * from "./ConversationDetail.vue?vue&type=script&lang=js&"
import style0 from "./ConversationDetail.vue?vue&type=style&index=0&id=f0090338&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0090338",
  null
  
)

export default component.exports